import { render, staticRenderFns } from "./OfferPricePage.vue?vue&type=template&id=04c633c3&scoped=true&"
import script from "./OfferPricePage.vue?vue&type=script&lang=js&"
export * from "./OfferPricePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c633c3",
  null
  
)

export default component.exports